export const OVERVIEW_THANK_YOU_URL = 'https://glowing-fortnight-2mk3g3w.pages.github.io/'

export function navigateToOverviewThankYou(assign: (url: string) => void = url => window.location.assign(url)) {
  assign(OVERVIEW_THANK_YOU_URL)
}
